import React from "react";
import "./headboardForoInterna.scss";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import { formatDate } from "../../../utils/helpers";
import Breadcrumb from '../../atoms/breadcrumb/breadcrumb';
import { ThemeColors } from "../../../data/foro.data.js"

const HeadboardForoInterna = (props: ReferenciaCabecera) => {

    const { referenciaMultimedia: refMultimedia } = props;
    const themeColor = ThemeColors[refMultimedia.tematica ? refMultimedia.tematica : "default"];

    return (
        <div className="o-foro-headboard" style={{"background": themeColor.bgColorBanner}}>
            <div className="container">
                <Breadcrumb content={props.migaDePan} />
                <div className="o-foro-headboard__container">
                    <div className="o-foro-headboard__container__main">
                        <div className="o-foro-headboard__intro">
                            <h1 className="o-foro-headboard__intro__title">
                                {refMultimedia.tituloMultimedia}
                            </h1>
                            <span className="o-foro-headboard__intro__span">
                                {refMultimedia.tematica}
                            </span>
                            <div className="o-foro-headboard__intro__text">
                                {refMultimedia.textoIntroductorio}
                            </div>
                            <div className="box-article">
                                <span className="o-foro-headboard__intro__date">
                                    {formatDate(refMultimedia.createdAt)}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeadboardForoInterna;
